<div [class.form-group]="appendLabel">
  <label *ngIf="appendLabel" class="input-label"
    >{{ labelName }} <span *ngIf="flagAsRequired">*</span>
  </label>
  <div
    [class.input-group]="true"
    ngbDropdown
    class="search-dropdown"
    container="body">
    <button
      class="btn btn-outline-primary dropdown-button"
      id="dropdownSearch"
      ngbDropdownToggle
      [disabled]="formcontrol?.disabled"
      (click)="focusOnInput()"
      [class.no-btn-hover-effect]="!hoverEffect">
      <span class="dropdown-button-text">
        {{ getDisplayValue() }}
      </span>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownSearch">
      <form>
        <div class="form-group search-box">
          <input
            #input
            (keyup)="onFilterChanged($event)"
            type="text"
            class="form-control search-box-field"
            placeholder="Start typing" />
        </div>
        <div class="dropdown-divider"></div>
        <div class="form-group result-box" #resultBox>
          <a
            class="result-box-item"
            *ngFor="let item of filteredItems$ | async"
            ngbDropdownItem
            (click)="onItemSelected(item.value, item.description)">
            {{ item.description }}
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
